// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .rule-row[data-v-2863c146] {\n  border: 1px solid #e4e4e4;\n}", ""]);
// Exports
module.exports = exports;
